export const matchKeys = {
  all: ['match'] as const,
  questions: (species: 'Cat' | 'Dog') =>
    [...matchKeys.all, 'questions', species] as const,
  publicResults: (matchResultsId: string) =>
    [...matchKeys.all, 'public', matchResultsId] as const,
};
